import { currencyList } from '@unistocks/shared/currencies';
import { t } from '@unistocks/shared/localization/index.ts';
import { sortByKey } from '@unistocks/shared/utils/util';
import { SelectOption } from '@unistocks/types';
import { useMemo } from 'react';

export const useCurrencyList = () =>
  useMemo(
    () =>
      currencyList
        .map(
          currency =>
            ({
              key: currency,
              value: currency,
              title: `${t(`::Currency:${currency}`)}`,
              subTitle: currency
            }) as SelectOption<string>
        )
        .sort(sortByKey('key')),
    []
  );
